module.exports = __webpack_public_path__ + "static/img/IMG_20160918_152159.6a2f6b34.jpg";